import { dayTimeEnum } from "utils/enums";
import { array, date, number, object, string } from "yup";

const RequestEditSchema = object({
  reason: string().required("required").trim(),
  admin: number().required("required").min(0, "required"),
  patient: number().required("required").min(0, "required"),
  practitioner: number().required("required").min(0, "required"),
  activities: array().of(number().required("required")).min(1, "required"),
  prescriptions: array()
    .of(
      object().shape({
        prescriptionId: number().required("required"),
        name: string(),
        numberOfTablets: number().required("required").min(1, "required"),
        lengthOfDays: number().required("required").min(1, "required"),
        timesOfUsage: array()
          .of(
            string().is(
              [dayTimeEnum.MORNING, dayTimeEnum.AFTERNOON, dayTimeEnum.NIGHT],
              "must be a valid time of day"
            )
          )
          .min(1, "must select atleast one time of day")
          .required("required"),
        note: string().trim(),
      })
    )
    .min(1, "required")
    .required("required"),
  prescriptionNumber: string().required("required"),
  additionalNotes: string().trim(),
});

export const RequestHomeVisitEditSchema = object({
  reason: string().required("required").trim(),
  admin: number().required("required").min(0, "required"),
  patient: number().required("required").min(0, "required").nullable(),
  activities: array().of(number().required("required")).min(1, "required"),
  when: date()
    .min(
      new Date(
        Date.now() -
          2 * 24 * 60 * 60 * 1000 +
          (new Date().getHours() + 1) * 60 * 60 * 1000
      ),
      "must be a date not less than two days from now"
    )
    .required("required"),
  time: string()
    .required("required")
    .matches(
      RegExp(/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/g),
      "must match 15:30 (24hrs)format"
    ),
  additionalNotes: string().trim(),
});

export default RequestEditSchema;
